<template>
	<nk-wrapper v-if="context.aemter" spacing="md">
		<nk-list variant="overview">
			<nk-list-item
				v-for="(amt, amtIndex) in context.aemter"
				:key="`amt-${amtIndex}`"
			>
				<section>
					<nk-title tag="h1" size="2xl">
						{{ amt.titel }}
					</nk-title>

					<nk-row vertical-gutter="2">
						<nk-col v-if="amt.kontakt || amt.adresse" cols="full" md="auto">
							<nk-title tag="h2" size="xl">Anschrift</nk-title>
							<nk-address
								variant="vertical"
								v-bind="{...amt.kontakt, ...amt.adresse}"
							/>
						</nk-col>
						<nk-col v-if="amt.oeffnungszeiten" cols="full" md="auto">
							<nk-title tag="h2" size="xl">Sprechzeiten</nk-title>
							<div class="nk-cms-content" v-html="amt.oeffnungszeiten" />
						</nk-col>
					</nk-row>
				</section>
			</nk-list-item>
		</nk-list>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateAemterUebersicht',

	mixins: [TemplatesDefault],
};
</script>
